import React,{useEffect} from 'react';
import CustomCarousel from './CustomCarousel';
import Spinner from '../../../SharedModule/Spinner/Spinner';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { Button } from 'react-bootstrap';

export default function LoginForm(props) {
    const [spinnerLoader, setSpinnerLoader] = React.useState(false);

    /* useEffect(()=>{
        localStorage.setItem("isLoggedIn","ioxadmin");
    },[]) */
    const redirectToLogin = () => {
        setSpinnerLoader(true);
        setTimeout(function () {
          setSpinnerLoader(false);
          window.location.href = process.env.REACT_APP_ADMIN_MEMBER
        }, 3000);
      }
      const openDocument=(name)=>{
            localStorage.setItem("IoxDocName",name);
            window.open("/doc");
      }

    const [dialogOpen, setDialogOpen] = React.useState(false);
    const [dialogType, setDialogType] = React.useState('');
    const [targetAction, setTargetAction] = React.useState('');
    const [memberLoginUrl] = React.useState(process.env.REACT_APP_MEMBER);
    const [adminLoginUrl] = React.useState(process.env.REACT_APP_ADMIN);

    const showPrivacyPolicyDialog = (actionUrl) => {
        setDialogOpen(true);
        setDialogType('showPrivacyPolicy')
        setTargetAction(actionUrl)
        return true;
    };
    const acceptPrivacyPolicy = () => {
        setDialogOpen(false);
        window.open(targetAction,"_self")
    };

    return (

        <div className="container custom-container py-3">

            <Dialog
                open={dialogOpen}
                className="custom-alert-box">
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <span style={{fontWeight: 'bold'}}>PRIVACY AND SECURITY NOTICE</span>
                        <br></br><br></br>
                        Anyone using this system must abide by Conduent policies and is hereby notified that all Conduent systems and activities are monitored. If you have any questions or concerns, contact DataPrivacy@conduent.com.

                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { setDialogOpen(false); }} color="primary" autoFocus>
                        Cancel
                    </Button>
                    {dialogType === 'showPrivacyPolicy' && (
                        <Button onClick={() => { acceptPrivacyPolicy() }} color="primary" className="btn btn-success">
                            I Agree
                        </Button>
                    )
                    }
                </DialogActions>
            </Dialog>

            <div className="login-tab">
                <div className="row">
                    <div className="col-sm-12 col-md-7">
                        <CustomCarousel />
                    </div>
                    <>
                        <div className="col-sm-12 col-md-5">

                            <div className="login_block">
                                {/* New Design start */}
                                <div className="mem-link-right">
                                    <div className="pt-1">
                                        <div className="admin-login-wrapper float-right">
                                            <div className="link-icon icon-admin-login"></div>
                                            <div className="link-text">
                                                {/* <a href="/appPayerManagement" title="Admin Login">Admin Login</a>  */} 
                                                <a href="javascript:void(0)" onClick={()=>showPrivacyPolicyDialog(adminLoginUrl)} title="Admin Login">Admin Login</a>
                                            </div>
                                        </div>
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="mem-login-link-wrapper">
                                        <div className="mem-login-link-inner my-3">

                                            <div className="link-block p-3">
                                                <div className="link-text icon-pos icon-new-mem">
                                                    <div className="link-lbl">New Member?</div>
                                                    <a href="javascript:void(0)" onClick={()=>showPrivacyPolicyDialog("/registration")} title="Register here">Register here</a><br />
                                                    {/* <button type="button"onClick={() => showPrivacyPolicyDialog("/registration")}className="link-style-button" title="Register here">Register here</button> */}
                                                    <button type="button" onClick={() => openDocument("Education_Materials")} className="link-style-button"   title="Review educational materials here"  >  Review educational materials here </button>
                                                </div>
                                            </div>

                                            <div className="link-block p-3">
                                                <div className="link-text icon-pos icon-app-dev">
                                                    <div className="link-lbl">App Developer</div>
                                                    <a  href="javascript:void(0)" onClick={()=>showPrivacyPolicyDialog("/appRegistration")} title="Register your app here">Register your app here</a><br />
                                                    <button type="button"onClick={() => openDocument("API")} className="link-style-button"title="API Documentation">API documentation</button>
                                                </div>
                                            </div>
                                            <div className="link-block p-3">
                                                <div className="link-text icon-pos icon-exist-mem">
                                                    <div className="link-lbl">Member Consent Management</div>
                                                    <a title="Login here" href="javascript:void(0)" onClick={()=>showPrivacyPolicyDialog(memberLoginUrl)}>Login here</a><br />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* New Design End */}
                            </div>
                        </div>
                    </>
                </div>

            </div>
        </div>
    )
}
